// if (!customElements.get('video-popup')) {
//   class VideoPopup extends HTMLElement {
//     constructor() {
//       super();
//       this.id = this.dataset.id;
//     }

//     connectedCallback() {
//       Fancybox.bind(`[data-fancybox="${this.id}"]`, {});
//     }
//   }
//   customElements.define('video-popup', VideoPopup);
// }
 document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.video-inline').forEach(function(box){
      var previewSrc = box.getAttribute('data-preview-src');
      var slot = box.querySelector('.video-inline__preview');
      if (previewSrc && slot) {
        var iframe = document.createElement('iframe');
        iframe.src = previewSrc;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('loading', 'lazy');
        iframe.setAttribute('title', 'Video preview');
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = '0';
        slot.appendChild(iframe);
        iframe.addEventListener('load', function(){
          var img = box.querySelector('.video-inline__img');
          if (img) img.style.display = 'none';
        });
      }
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-play-inline]');
    if (!btn) return;

    var id = btn.getAttribute('data-play-inline');
    var box = document.getElementById(id);
    if (!box) return;

    var mainSrc = box.getAttribute('data-main-src');
    if (mainSrc) {
      // YouTube / Vimeo
      var ratio = box.querySelector('.video-inline__ratio');
      if (!ratio) return;
      ratio.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = mainSrc;
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('loading', 'lazy');
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = '0';
      ratio.appendChild(iframe);
    } else {
      // Shopify-hosted
      var previewVid = box.querySelector('.video-inline__bg');
      var mainVid = box.querySelector('.video-inline__main');
      var cover = box.querySelector('.video-inline__cover');
      if (cover) cover.remove();
      if (previewVid) previewVid.style.display = 'none';
      if (mainVid) {
        mainVid.style.display = 'block';
        try { mainVid.setAttribute('controls', 'controls'); } catch(e){}
        try { mainVid.muted = false; } catch(e){}
        if (mainVid.play) mainVid.play();
      }
    }
  }, { passive: true });